import { render, staticRenderFns } from "./Afterlanding.vue?vue&type=template&id=1b528789"
import script from "./Afterlanding.vue?vue&type=script&lang=js"
export * from "./Afterlanding.vue?vue&type=script&lang=js"
import style0 from "./Afterlanding.vue?vue&type=style&index=0&id=1b528789&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports